import dayjs from 'dayjs';

export function formatCurrency(value, { symbol = '₹', decimals = 2 } = {}) {
  if (value === null || value === undefined || value === '') return '—';
  const num = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (!Number.isFinite(num)) return '—';
  return `${symbol} ${num.toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
}

export function formatNumber(value, decimals = 0) {
  if (value === null || value === undefined || value === '') return '—';
  const num = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (!Number.isFinite(num)) return '—';
  return num.toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function formatDate(value) {
  if (!value) return '—';
  return dayjs(value).format('DD MMM YYYY');
}

export function formatDateTime(value) {
  if (!value) return '—';
  return dayjs(value).format('DD MMM YYYY, HH:mm');
}

export function formatRelative(value) {
  if (!value) return '—';
  const d = dayjs(value);
  const now = dayjs();
  const secs = now.diff(d, 'second');
  if (secs < 60) return `${secs}s ago`;
  const mins = now.diff(d, 'minute');
  if (mins < 60) return `${mins}m ago`;
  const hrs = now.diff(d, 'hour');
  if (hrs < 24) return `${hrs}h ago`;
  const days = now.diff(d, 'day');
  if (days < 30) return `${days}d ago`;
  return d.format('DD MMM YYYY');
}
